import React, { useEffect, useState } from "react";
import FingerprintIcon from "../../../assets/images/generico/FingerprintIcon";
import { IonSpinner } from "@ionic/react";
import "./BiometricSplash.css";

const BiometricSplash = ({ 
  onCancel, 
  lastUser, 
  biometryTypeName,
  autoStartDelay = 3000 
}) => {
  const [countdown, setCountdown] = useState(Math.floor(autoStartDelay / 1000));
  const [isAuthenticating, setIsAuthenticating] = useState(false);

  useEffect(() => {
    // Countdown timer
    if (countdown > 0 && !isAuthenticating) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0 && !isAuthenticating) {
      // Start authentication automatically after countdown
      setIsAuthenticating(true);
    }
  }, [countdown, isAuthenticating]);

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div className="biometric-splash-container">
      <div className="biometric-splash-content">
        {/* Logo */}
        <div className="biometric-splash-logo">
          <img
            style={{ width: 160, height: 66 }}
            src="../../../../assets/images/empresa/IsoLogo.png"
            alt="logo"
          />
        </div>

        {/* Biometric Icon */}
        <div className="biometric-splash-icon">
          {isAuthenticating ? (
            <IonSpinner name="crescent" className="biometric-splash-spinner" />
          ) : (
            <div className="biometric-splash-fingerprint">
              <FingerprintIcon color="var(--color-white)" width={80} height={80} />
              <div className="biometric-splash-pulse"></div>
            </div>
          )}
        </div>

        {/* Status Text */}
        <div className="biometric-splash-text">
          {isAuthenticating ? (
            <>
              <h2 className="rb24b c-latex10">Autenticando...</h2>
              <p className="rb16m c-grey45">
                Coloca tu {biometryTypeName.toLowerCase()}
              </p>
            </>
          ) : (
            <>
              <h2 className="rb24b c-white">Bienvenido</h2>
              <p className="rb16m c-grey45">
                Iniciando sesión automáticamente en {countdown}s
              </p>
            </>
          )}
          {lastUser && (
            <p className="rb14m c-grey65 biometric-splash-user">
              DNI: {lastUser}
            </p>
          )}
        </div>

        {/* Cancel Button */}
        <div className="biometric-splash-actions">
          <button
            className="biometric-splash-cancel-btn rb16m c-white"
            onClick={handleCancel}
          >
            Iniciar con contraseña
          </button>
        </div>
      </div>
    </div>
  );
};

export default BiometricSplash;


